import React, { useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Item,
  View,
  Key,
} from "@adobe/react-spectrum";
import UserInfo from "./UserInfo";
import Attachments from "./Attachments";

const tabs = [
  { id: 1, name: "User info", children: <UserInfo /> },
  { id: 2, name: "Attachments", children: <Attachments /> },
];

const ChatInfo: React.FC = () => {
  type Tab = (typeof tabs)[0];
  let [tabId, setTabId] = useState<Key>(1);

  return (
    <View
      UNSAFE_style={{
        background: "#F8F8F8",
        height: "100%",
      }}
    >
      <Tabs
        aria-label="chat-tabs"
        items={tabs}
        onSelectionChange={setTabId}
        defaultSelectedKey={1}
        selectedKey={tabId}
      >
        <TabList
          UNSAFE_className="custom-tab-list"
        >
          {(item: Tab) => <Item>{item.name}</Item>}
        </TabList>
        <TabPanels>{(item: Tab) => <Item>{item.children}</Item>}</TabPanels>
      </Tabs>
    </View>
  );
};

export default ChatInfo;
